/**
 * commonService.js
 * Shared API service functions for common application data (client config, timezone, etc.)
 */
import { COMMON_URLS } from "./apiConfig";
import apiClient from "./apiInstance";

export const getClientConfig = async () => {
    try {
        const response = await apiClient.get(COMMON_URLS.GET_CLIENT_CONFIG);
        return response.data;
    } catch (error) {
        console.error("Error fetching client config:", error);
        throw new Error("Failed to fetch client configuration.");
    }
};

export const getClientTimezone = async () => {
    try {
        const response = await apiClient.get(COMMON_URLS.GET_CLIENT_TIMEZONE);
        return response.data;
    } catch (error) {
        console.error("Error fetching client timezone:", error);
        throw new Error("Failed to fetch client timezone.");
    }
};